/* eslint-disable tailwindcss/no-custom-classname */
import React, { FC, useEffect, useState } from "react";

import { PcAdvertisementFooter } from "@/components/organisms/footer/PcAdvertisementFooter";
import { SpAdvertisementFooter } from "@/components/organisms/footer/SpAdvertisementFooter";
import useWindowSize from "@/hooks/useWindowSize";

export const AdvertisementFooter: FC = () => {
  const { isSp } = useWindowSize();

  const ref = React.useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entry) => {
        if (!entry[0].isIntersecting) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      },
      { root: null, rootMargin: "0px 0px", threshold: 0 },
    );

    if (ref.current === null) return;

    observer.observe(ref.current);

    const { current } = ref;

    return () => {
      observer.unobserve(current);
    };
  }, [isSp]);

  return (
    <>
      {isSp ? (
        <SpAdvertisementFooter isSticky={isSticky} stickyRef={ref} />
      ) : (
        <div ref={ref}>
          <PcAdvertisementFooter isSticky={isSticky} />
        </div>
      )}
    </>
  );
};
